import { FirebaseApp, initializeApp } from 'firebase/app'
import { useEffect, useState } from 'react'
import {
  AppCheck,
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken,
} from 'firebase/app-check'

if (process.env.NODE_ENV !== 'production') {
  // @ts-ignore
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true
}

// Module-level variables to hold the initialized instances
let firebaseAppInstance: FirebaseApp | undefined
let appCheckInstance: AppCheck | undefined

export const useGetAppcheck = () => {
  const [firebaseApp, setFirebaseApp] = useState<FirebaseApp>()
  const [appCheck, setAppCheck] = useState<AppCheck | undefined>(
    appCheckInstance
  )
  const [appCheckToken, setAppCheckToken] = useState<string>()

  useEffect(() => {
    if (!firebaseAppInstance) {
      // Initialize Firebase app if none exists
      firebaseAppInstance = initializeApp(
        {
          apiKey: 'AIzaSyDj4VVmQgxfq-59EBB4pZUVBZOOiE_FsPE',
          authDomain: 'captchadatabases.firebaseapp.com',
          databaseURL:
            'https://2024-movie-assistant.europe-west1.firebasedatabase.app/',
          projectId: 'captchadatabases',
          messagingSenderId: '78621128630',
          appId: '1:78621128630:web:cf853725930503985df317',
        },
        'APPCHECK'
      )
      setFirebaseApp(firebaseAppInstance)
    }

    if (!appCheckInstance && firebaseAppInstance) {
      appCheckInstance = initializeAppCheck(firebaseAppInstance, {
        provider: new ReCaptchaV3Provider(
          '6LeQO3YiAAAAANqUBx7Jy2hrDYKhk-6Qv2tvARo1'
        ),
        isTokenAutoRefreshEnabled: true,
      })
      setAppCheck(appCheckInstance)
      getToken(appCheckInstance, false)
        .then((appCheckTokenResponse) => {
          setAppCheckToken(appCheckTokenResponse.token)
        })
        .catch((error) => {
          console.error('Error fetching App Check token:', error)
        })
    }
  }, [])

  return { appCheck, appCheckToken }
}
